import { X } from "lucide-react";
import { FILTER_GROUPS, totalActive } from "../../lib/filters";

export const ActiveFilterChips = ({ filters, onRemove, onClear }) => {
  if (totalActive(filters) === 0) return null;

  const chips = FILTER_GROUPS.flatMap((g) =>
    filters[g.id].map((v) => ({ groupId: g.id, value: v }))
  );

  return (
    <div
      data-testid="active-filter-chips"
      className="flex flex-wrap items-center gap-2"
    >
      {chips.map((c) => (
        <button
          key={`${c.groupId}-${c.value}`}
          onClick={() => onRemove(c.groupId, c.value)}
          data-testid={`chip-${c.groupId}-${c.value.replace(/[^a-zA-Z0-9]/g, "")}`}
          className="group inline-flex items-center gap-2 rounded-full bg-stone border border-beige pl-3.5 pr-2.5 py-1.5 text-xs font-medium text-charcoal transition-colors duration-300 hover:bg-charcoal hover:text-ivory hover:border-charcoal"
        >
          {c.value}
          <X size={13} strokeWidth={2} />
        </button>
      ))}
      <button
        onClick={onClear}
        data-testid="clear-all-chips"
        className="link-sweep text-xs font-medium text-taupe ml-1"
      >
        Clear all
      </button>
    </div>
  );
};
